import { LocationSchema } from '@eigtech/claims-v2-types';
import { ContactCornSchema } from '@eigtech/contacts-types';
import { JobCornSchema, JobIdSchema, JobLocationSchema } from '@eigtech/restoration-types';
import { CurrentClaimCornSchema } from '@eigtech/shared-corn-helper';
import { z } from 'zod';
export const PhotoReportParamsSchema = z.object({
    carrierContactId: ContactCornSchema.optional(),
    companyAddress: z.string().array(),
    companyName: z.string(),
    claimNumber: z.string().optional(),
    entityId: z.union([CurrentClaimCornSchema, JobCornSchema]),
    insuredName: z.string(),
    jobId: JobIdSchema.optional(),
    lossLocation: LocationSchema.or(JobLocationSchema),
    policyNumber: z.string().optional(),
    logoPath: z.string().optional(),
});
